var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0",staticStyle:{"width":"98%"}},_vm._l((_vm.inputs),function(input,index){return _c('v-col',{key:index,staticClass:"py-0",attrs:{"cols":"6"}},[_c('CalcInput',{attrs:{"input-details":input},model:{value:(input.value),callback:function ($$v) {_vm.$set(input, "value", $$v)},expression:"input.value"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }